'use client';
var ACCORDION_ERRORS_CONTEXT = "Компонент Accordion не найден в дереве";
var ACCORDION_ERRORS_VALUE = "Компонент Accordion.Item был добавлен в дерево с невалидным или неуказанным value.";

export { ACCORDION_ERRORS_CONTEXT, ACCORDION_ERRORS_VALUE };
